export const loader = {
    namespaced: true,
    state: {count: 0, lastHit: 0},
    actions: {
        start({commit}) {
            commit('inc')
        },
        end({commit}) {
            commit('dec')
        }
    },
    mutations: {
        inc(state) {
            state.count++;
            state.lastHit = Date.now();
        },
        dec(state) {
            state.count--
        }
    }
}
